import { useWindowDimensions } from './use-window-dimensions';

export const useIsWideScreen = () => {
  const dimensions = useWindowDimensions();
  return dimensions.width >= 768;
};
